import React, { useState, useEffect, useContext, useRef } from 'react';
import './TopAlarmers.css';
import convenienceApi from '../../common/api/convenience';
import Card from '../Card/Card';
import CardContent from '../Card/CardContent';
import CardLink from '../Card/CardLink';
import CardLinkReport from '../Card/CardLinkReport';
import { EnvironmentContext } from '../../contexts/EnvironmentContext';
import { CardTopAlarmsContext } from '../../contexts/CardTopAlarmsContext';
import TopAlarmersContent from './TopAlarmersContent';
import TopAlarmersTimeRange from './TopAlarmersTimeRange';
import TopAlarmersLoadingStatus from './TopAlarmersLoadingStatus';
import logComponent from '../../common/logComponent';

export default function TopAlarmers({ moduleDescription }) {
  const environmentContext = useContext(EnvironmentContext);
  const cardTopAlarmsContext = useContext(CardTopAlarmsContext); 
  const { timeRanges } = cardTopAlarmsContext;
  const [currentTimeRange, setCurrentTimeRange] = useState(timeRanges[0]);
  const { hasToken, activeUser: user, reportsEnabled } = environmentContext;
  const loadingRef = useRef(false);

  if (logComponent('TopAlarmers')) { console.debug('TopAlarmers rendered'); }


  const setLoadingRef = (el) => {
    if (logComponent('Secured')) { console.debug('TopAlarmers setLoadingRef'); }
    loadingRef.current = el;
  }
  useEffect(() => {
    if (logComponent('TopAlarmers')) {console.debug('TopAlarmers onMount'); }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    if (!hasToken) return;
  }, []);

  useEffect(() => {
    if (logComponent('TopAlarmers')) {console.debug('TopAlarmers useEffect [environmentContext.hasToken, currentTimeRange, environmentContext.activeUser]'); }
    if (!hasToken) return;
    loadAlarmers();

  }, [environmentContext.hasToken, currentTimeRange, environmentContext.activeUser]);



  useEffect(() => {
    if (logComponent('TopAlarmers')) {console.debug('TopAlarmers useEffect [environmentContext.selectedMonitoredIndividual, environmentContext.activeUser, environmentContext.selectedUnit ]'); }
    if (!hasToken) return;

    if (currentTimeRange == timeRanges[0]) {
      loadAlarmers();
    }

  }, [environmentContext.selectedMonitoredIndividual, environmentContext.activeUser, environmentContext.selectedUnit]);

  useEffect(() => {
    if (logComponent('TopAlarmers')) {console.debug('TopAlarmers useEffect [environmentContext.selectedMonitoredIndividual, environmentContext.activeUser, environmentContext.selectedUnit ]'); }
    if (!hasToken) return;

    if (currentTimeRange !== timeRanges[0]) {
      setCurrentTimeRange(timeRanges[0])
    }

  }, [environmentContext.selectedMonitoredIndividual, environmentContext.activeUser, environmentContext.selectedUnit]);



  const loadAlarmers = () => {
    if (logComponent('TopAlarmers')) {console.debug('TopAlarmers loadAlarmers'); }
    if (!hasToken || loadingRef.current) return;
    setLoadingRef(true);

    const { setTopAlarms, setTopAlarmsMonitoredIndividualsAndUnits, setTopAlarmsLoading, setTopAlarmsError } = cardTopAlarmsContext;

    let days = null;

    switch (currentTimeRange) {
      case 'Past 7 days':
        days = 7;
        break;
      case 'Past 30 days':
        days = 30;
        break;
      default:
        break;
    }
    setTopAlarmsMonitoredIndividualsAndUnits(null);
    setTopAlarms(null);
    setTopAlarmsLoading(true);
    setTopAlarmsError(false);

    convenienceApi.getMostAlarmsData(days)
      .then(
        result => {
          setTopAlarmsMonitoredIndividualsAndUnits(result.map(item => item.monitoredIndividual ? item.monitoredIndividual : item.unit));
          setTopAlarms(result);
          setTopAlarmsLoading(false);
          setTopAlarmsError(false);
          setLoadingRef(false);
        },
        error => {
          setTopAlarmsMonitoredIndividualsAndUnits(null);
          setTopAlarms(null);
          setTopAlarmsLoading(false);
          setTopAlarmsError(true);
          setLoadingRef(false);
        }
    );


  }



  const updateTimeRange = (newRange) => {
    if (logComponent('TopAlarmers')) {console.debug('TopAlarmers updateTimeRange'); }
    const { setTopAlarmsTimeRange } = cardTopAlarmsContext;
    setTopAlarmsTimeRange(newRange);
    setCurrentTimeRange(newRange);
  }

  return (
    <Card className="Top-Alarmers" title="Most alarms" moduleDescription={moduleDescription} icon="exclamation-triangle" >
      <CardContent>
        <TopAlarmersTimeRange updateTimeRange={updateTimeRange} />
        <TopAlarmersContent />
        <TopAlarmersLoadingStatus reloadAction={ loadAlarmers } />
      </CardContent>
      {
        user.groupTypeString !== 'Family' && reportsEnabled &&
        <CardLink>
            <CardLinkReport reportId={4} />
        </CardLink>
      }
    </Card>
  )
}
